import {
    PhmsIntakeDisplayError,
    mapPhmsIntakeError,
} from "../../intake/phms-manual-intake-submission.models";

export { mapPhmsIntakeError };
export type { PhmsIntakeDisplayError };

/**
 * Terminal-lifecycle request/DTO shapes for the PHMS post-hearing surface, mirroring the backend
 * contracts in PhmsCaseCompletionModels.cs (story 968) and PhmsCloseoutPackageModels.cs (story 972).
 */

/** POST /api/phms/cases/{id}/complete body (OperationsCaseCompletionRequest). */
export interface OperationsCaseCompletionRequest {
    reason?: string;
    completedByParticipantId?: number;
}

/** POST /api/phms/cases/{id}/closeout body (OperationsCaseCloseoutRequest). */
export interface OperationsCaseCloseoutRequest {
    packageReference?: string;
    closedByParticipantId?: number;
}

/** A single preserved lifecycle-history entry (OperationsCaseLifecycleHistoryEntryDto). */
export interface OperationsCaseLifecycleHistoryEntryDto {
    stepCode: string;
    statusCode: string;
    startedUtc?: string | null;
    completedUtc?: string | null;
    statusChangedUtc: string;
}

/** Result of completing a case candidate (OperationsCaseCompletionDto). */
export interface OperationsCaseCompletionDto {
    workflowInstanceId: number;
    subjectTypeCode: string;
    subjectId: number;
    caseStatusCode: string;
    completionReason?: string | null;
    completedAtUtc: string;
    completedByParticipantId?: number | null;
    isTerminal: boolean;
    lifecycleHistory: OperationsCaseLifecycleHistoryEntryDto[];
}

/** Result of closing a case/proceeding (OperationsCaseCloseoutDto). */
export interface OperationsCaseCloseoutDto {
    workflowInstanceId: number;
    subjectTypeCode: string;
    subjectId: number;
    closeoutStatusCode: string;
    decisionRecordId: number;
    packageReference: string;
    closedAtUtc: string;
    closedByParticipantId?: number | null;
    isTerminal: boolean;
    lifecycleHistory: OperationsCaseLifecycleHistoryEntryDto[];
}

/** Permission gating both terminal lifecycle actions. */
export const WORKFLOW_RUNTIME_TRANSITION = "workflow_runtime.transition";
